import { ComponentType } from 'react';
import { SetRequired } from 'type-fest';
import ControlledFormField from './ControlledFormField';

// these props are provided by ControlledFormField
type ProvidedPropKeys = 'value' | 'error' | 'onChange' | 'onBlur' | 'setFieldValue';

const withFormControl = <T extends { name?: string }>(
  Component: ComponentType<T>,
): FC<Omit<SetRequired<T, 'name'>, ProvidedPropKeys>> => {
  const WithFormControl = (props: SetRequired<T, 'name'>) => (
    <ControlledFormField {...(props as any)} name={props.name} Component={Component} />
  );
  return WithFormControl as any;
};

export default withFormControl;
